import { render, staticRenderFns } from "./FeedbackEsc5Act3.vue?vue&type=template&id=10bb2a86&"
var script = {}
import style0 from "./FeedbackEsc5Act3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports